import CommentComponent from "./CommentComponent";

export default CommentComponent;
